import React from 'react';
import { useReminderModal } from './ReminderModalContext';
import { useEventInfo } from '@shared/utils/eventInfo';
import { ReminderModal } from '@shared/components/ReminderModal';

// Wrapper component that renders the ReminderModal
export const ReminderModalWrapper: React.FC = () => {
  const { isOpen, onClose } = useReminderModal();
  const { eventInfo } = useEventInfo();

  // TODO: add telemetry for reminder modal
  const reminderModalTelemetry = {
    remindMeLaterDialog: {
      enter: () => ({}),
    },
    formFieldInteracted: (label: string, inputAction: 'onFocus' | 'onChange') => ({}),
    remindMeLaterFormSubmitted: (duration: string, reminderDate: string) => ({}),
    remindMeLaterDialogDismissed: () => ({}),
    remindMeLaterDialogOutsideClick: () => ({}),
  };

  if (!isOpen || !eventInfo?.eventId) {
    return null;
  }

  return (
    <ReminderModal
      isOpen={isOpen}
      onClose={onClose}
      eventId={eventInfo.eventId}
      telemetry={reminderModalTelemetry}
      customOffset={{ x: 16, y: 38 }}
      showNoThanksButton={false}
    />
  );
};
